<div class="apm-card dashboard-card shadow hover-shadow" (click)="onCardClick($event)">
  @let _selectionDetails = selectionDetails();
  <div class="d-flex flex-row justify-content-between">
    <div class="text-md bold d-flex align-items-center overflow-hidden">
      <span class="text-truncate" data-testid="quote-card-title" matTooltip="{{ _selectionDetails.title }}">
        {{ !_selectionDetails.title || _selectionDetails.title === '' ? 'Untitled' : _selectionDetails.title }}
      </span>
      <apm-icon
        class="ps-1"
        size="xs"
        [hoverOpacity]="true"
        [isButton]="true"
        (click)="copyCode($event)"
        icon="a_badge"
        matTooltip="{{ '448635' | apmTranslate: [selectionCode()] }}"
      ></apm-icon>
    </div>
    @if (selectionAlternativesCount() > 0) {
      <div class="d-flex flex-row">
        <span class="text apm-text-red me-1">{{ selectionAlternativesCount() }}</span>
        <apm-icon size="xs" icon="t_quote_alternatives" matTooltip="{{ 445065 | apmTranslate }}"></apm-icon>
      </div>
    }
  </div>
  <hr class="gray-divider-1" />
  <div class="my-2">
    <div class="italic">{{ 444978 | apmTranslate }} - {{ _selectionDetails.created.at | momentDate }}</div>
    <div class="italic">{{ 444979 | apmTranslate }} - {{ _selectionDetails.updated?.at | momentDate }}</div>
  </div>
  <div class="mb-2 d-flex align-items-center">
    <apm-badge [state]="_selectionDetails.status" badgeType="selection"></apm-badge>
    <apm-statistics-data-icons
      class="ms-1"
      [statisticData]="selection().offer.statisticData"
    ></apm-statistics-data-icons>
  </div>
  @if (selectedPrice() && hasPrices()) {
    <hr class="gray-divider-1" />
    <div class="d-flex align-items-center">
      <div class="d-flex flex-column">
        <div class="italic mb-1">{{ PRICE_TYPE_LABEL[selectedPrice()!] | apmTranslate }}</div>

        <apm-price
          [prices]="_selectionDetails.total"
          [priceType]="selectedPrice()"
          [currencySymbol]="currencySymbol()"
          additionalClass="text-md bold"
        ></apm-price>
      </div>
      <div class="ms-auto">
        <apm-price-toggle
          [prices]="_selectionDetails.total"
          [defaultPriceType]="selectedPrice()"
          (priceChanged)="priceChanged($event)"
        ></apm-price-toggle>
      </div>
    </div>
  } @else {
    <hr class="gray-divider-1" />
    <div class="italic">{{ 446025 | apmTranslate }}</div>
  }
  <div class="d-flex align-items-center mt-auto gap-2">
    <apm-news-unread-counter [unreadNews]="unreadNewsCount()"></apm-news-unread-counter>
    @if (isExpiring()) {
      <apm-icon
        class="d-inline-block"
        size="md"
        icon="i_expiration"
        matTooltip="{{ 445032 | apmTranslate }}"
      ></apm-icon>
    }
    @if (_selectionDetails.ticketsCount > 0) {
      <apm-icon class="d-inline-block" size="md" icon="i_ticket" matTooltip="{{ 444446 | apmTranslate }}"></apm-icon>
    }
  </div>
  @if (isCRM()) {
    <div class="crm-triangle">
      <span>CRM</span>
    </div>
  }
</div>
